import React from 'react';

import { observer } from 'mobx-react';

import {
  ButtonRow,
  PersonalInfoForm,
  PersonalInfoFormFormValues,
} from '../../../../components/customer-self-setup-components';
import { UseStepperReturn } from '../../../../../shared/hooks/useStepper';
import { personalInfoStore } from '../../../../stores/customerSelfSetupStores/personalInfoStore';
import { useScrollToTop } from '../../../../../shared/hooks/useScrollToTop';
import { questionnaireStore } from '../../../../stores/customerSelfSetupStores/questionnaireStore';
import { TermsAcceptCheckbox } from '../../../../../shared/components/TermsAcceptCheckbox/TermsAcceptCheckbox';

type PersonalInfoStepProps = {
  stepperMethods: UseStepperReturn;
};

const personalInfoFormId = 'personalInfoForm';

const PersonalInfoStep = observer(({ stepperMethods }: PersonalInfoStepProps) => {
  useScrollToTop();

  const {
    customerData,
    isCommunicationsAccepted,
    isMarketingAccepted,
    setIsCommunicationsAccepted,
    setIsMarketingAccepted,
  } = personalInfoStore;
  const { customerSportType } = questionnaireStore;

  const handleFormSubmit = async (data: PersonalInfoFormFormValues) => {
    personalInfoStore.setCustomerData(data);

    stepperMethods.goToNextStep();
  };

  return (
    <div>
      <PersonalInfoForm
        formConfig={{ defaultValues: customerData }}
        onSubmit={handleFormSubmit}
        formId={personalInfoFormId}
        customerSportType={customerSportType}
      />
      <TermsAcceptCheckbox
        isCommunicationsAccepted={isCommunicationsAccepted}
        isMarketingAccepted={isMarketingAccepted}
        setIsCommunicationsAccepted={setIsCommunicationsAccepted}
        setIsMarketingAccepted={setIsMarketingAccepted}
      />
      <ButtonRow
        noHandler={stepperMethods.goToPreviousStep}
        formId={personalInfoFormId}
      />
    </div>
  );
});

export { PersonalInfoStep };
